/**
 * <s-linkify-email> — turns plain-text email addresses inside it into mailto links.
 * Used on Shopify-rendered policy pages (e.g. Contact information) whose body text the theme can't edit.
 * Text already inside a link is left alone.
 */
const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;

class SLinkifyEmail extends HTMLElement {
  connectedCallback() {
    const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => (node.parentElement?.closest('a, script, style, textarea') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
    });
    /** @type {Text[]} */
    const nodes = [];
    while (walker.nextNode()) {
      const node = /** @type {Text} */ (walker.currentNode);
      EMAIL.lastIndex = 0;
      if (EMAIL.test(node.data)) nodes.push(node);
    }
    for (const node of nodes) {
      const fragment = document.createDocumentFragment();
      let last = 0;
      for (const match of node.data.matchAll(EMAIL)) {
        const index = match.index ?? 0;
        fragment.append(node.data.slice(last, index));
        const link = document.createElement('a');
        link.href = `mailto:${match[0]}`;
        link.textContent = match[0];
        link.className = 'font-bold underline underline-offset-4 hover:opacity-70';
        fragment.append(link);
        last = index + match[0].length;
      }
      fragment.append(node.data.slice(last));
      node.replaceWith(fragment);
    }
  }
}

if (!customElements.get('s-linkify-email')) customElements.define('s-linkify-email', SLinkifyEmail);
